// extracted by mini-css-extract-plugin
export var icon = "NoticeModule-module--icon--0OUJv";
export var wrapper = "NoticeModule-module--wrapper--7PiPL";